import { ListItemProps } from '@progress/kendo-react-dropdowns';
import { ReactElement, cloneElement } from 'react';

function FlyoutDropDownItem(li: ReactElement<HTMLLIElement>, itemProps: ListItemProps) {
  const liElement = cloneElement(li, {
    ...li.props,
    className: `${li.props.className} flyout-internal`,
    children: (
      <span className="flyout-internal">{itemProps.dataItem}</span>
    ) as unknown as HTMLCollection,
  });

  return liElement;
}

export default FlyoutDropDownItem;
